import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt="" style={{maxWidth: '100%'}}
                                                 src={require('@images/How to effectively challenge others.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>The White Flag as a classic image of surrender is thought to
                                                originate from the Eastern Han dynasty in what is now China
                                                (AD 25-220).<a className="superscripttext"
                                                               href="further_info.php?course=300"><sup>1</sup></a> It
                                                signifies an unarmed negotiator, intention to surrender or a
                                                desire to communicate.</p>
                                            <div className="border_subtitle">Getting others on board</div>
                                            <p>There are many different ways to challenge people
                                                effectively. One classic example where leaders made
                                                disastrous mistakes by not challenging one another happened
                                                in 1961 with John F Kennedy's failed invasion of Cuba. This
                                                phenomenon is known as 'Groupthink' and occurs when team
                                                members value harmony and consensus over full appraisal of
                                                the situation. It occurs most often when team members are
                                                similar, have close relationships, lack self-confidence and
                                                have a strong leader who takes sides. This effect has been
                                                seen in historical contexts, even as far back as the
                                                'Sanhedrin' in ancient Israel<a className="superscripttext"
                                                                                href="further_info.php?course=300"><sup>2</sup></a> where
                                                the legislative body designed several regulations described
                                                in ancient holy
                                                texts which show the use of coping strategies to prevent
                                                incidents of groupthink. </p>

                                            <div className="lightgreencontentbg lightgreenbottm">
                                                <div className="border_subtitle">The Bay of Pigs</div>
                                                <p>Kennedy consulted with his top advisors regarding a CIA
                                                    and military plan to use Cuban
                                                    exiles to overthrow Fidel Castro. They decided on a
                                                    covert invasion. However, Castro was alerted to the
                                                    threat, leading to the invaders being vastly outnumbered
                                                    and lacking air support, ammunition and an escape route.
                                                    This resulted in 1,200 US soldiers surrendering, and the
                                                    death of others. </p>
                                                <p>The following investigation found that Kennedy's advisors
                                                    did not challenge bad ideas in case
                                                    this upset group cohesion. For instance, the
                                                    Presidential advisor presented serious objections to the
                                                    invasion in a memorandum to the president, but did not
                                                    express these at team meetings. </p>
                                                <div className="uiheading"><p>Individuals not raising their
                                                    concerns and not challenging others' decisions or views
                                                    led to
                                                    poor decision making in this case. The group thought
                                                    they could not be defeated, the issues and problems were
                                                    rationalised away and they stereotyped the opposition as
                                                    weaker than them. As a consequence of the Bay of Pigs
                                                    disaster, President Kennedy changed the decision making
                                                    process to ensure this would encourage debate - this
                                                    alone prevented potential
                                                    future catastrophes. </p></div>
                                            </div>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}